import React from 'react';
import { Button, Space, Flex } from 'antd';

interface BookingActionButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  onCheckIn?: () => void;
  isSaveEnabled: boolean;
  showCheckIn: boolean;
  isCancelEnabled: boolean;
}

const BookingActionButtons: React.FC<BookingActionButtonsProps> = ({ 
  onSave, 
  onCancel, 
  onCheckIn,
  isSaveEnabled,
  showCheckIn,
  isCancelEnabled
}) => {
  return (
    <Flex justify="center">
      <Space>
        {showCheckIn && onCheckIn && (
          <Button
            data-testid="booking-checkin-btn"
            type="primary"
            onClick={onCheckIn}
            style={{ backgroundColor: "#52c41a" }}
          >
            Check In
          </Button>
        )}
        <Button
          data-testid="booking-save-btn"
          type="primary"
          onClick={onSave}
          disabled={!isSaveEnabled}
        >
          Save Booking
        </Button>
        <Button
          data-testid="booking-cancel-btn"
          type="primary"
          onClick={onCancel}
          danger
          disabled={!isCancelEnabled}
        >
          Cancel
        </Button>
      </Space>
    </Flex>
  );
};

export default BookingActionButtons;